<template>
  <v-dialog v-model="show" persistent max-width="1000px">
    <v-card v-if="Choosen != null">
      <v-toolbar color="light-green darken-1" dark>
        <v-toolbar-title class="headline"
          >Ärende: {{ Choosen.name }}

          <v-btn
            v-if="
              Choosen.steps[Choosen.steps.length - 1].step ==
              'Avslut & Arkivering'
            "
            dark
            color="blue-grey darken-1"
          >
            Arkiverad
            <v-icon dark> archive </v-icon>
          </v-btn>
          <v-btn v-else dark :color="diffrentSteps.find(x=> x.text== Choosen.steps[Choosen.steps.length - 1].step).color">
            Nuvarande steg:
            {{ Choosen.steps[Choosen.steps.length - 1].step }}
             <v-icon dark> {{diffrentSteps.find(x=> x.text== Choosen.steps[Choosen.steps.length - 1].step).icon}} </v-icon>
          </v-btn></v-toolbar-title
        >
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-flex>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mx-2"
                  fab
                  dark
                  small
                  @click="DiscussHide = !DiscussHide"
                  v-bind="attrs"
                  v-on="on"
                  color="yellow ligthen-1"
                >
                  <v-icon dark> question_answer </v-icon>
                </v-btn>
              </template>
              <span>Diskussion</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mx-2"
                  fab
                  dark
                  small
                  @click="NextHide = !NextHide"
                  v-bind="attrs"
                  v-on="on"
                  color="green ligthen-1"
                >
                  <v-icon dark> arrow_forward_ios </v-icon>
                </v-btn>
              </template>
              <span>Nästa steg</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mx-2"
                  fab
                  dark
                  small
                  @click="Timeline = !Timeline"
                  v-bind="attrs"
                  v-on="on"
                  color="red ligthen-1"
                >
                  <v-icon dark> timeline </v-icon>
                </v-btn>
              </template>
              <span>Tidslinje</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mx-2"
                  fab
                  dark
                  small
                  @click="Feedback = !Feedback"
                  v-bind="attrs"
                  v-on="on"
                  color="blue ligthen-1"
                >
                  <v-icon dark> settings_input_antenna </v-icon>
                </v-btn>
              </template>
              <span>Återkoppling</span>
            </v-tooltip>
            <v-divider></v-divider>

            <v-expand-transition>
              <v-flex v-if="DiscussHide" cols="12" sm="6" md="4">
                <v-toolbar color="yellow darken-1" dark>
                  <v-toolbar-title class="headline"
                    >Diskussion</v-toolbar-title
                  ></v-toolbar
                >
                <div class="headline"></div>
                <Discuss
                  :Choosen="Choosen"
                  :id="this.id"
                  :teachernameandId="teachernameandId"
                  :membernameandId="membernameandId"
                />
              </v-flex>
            </v-expand-transition>
            <v-expand-transition>
              <v-flex v-if="NextHide">
                <v-toolbar color="green darken-1" dark>
                  <v-toolbar-title class="headline"
                    >Gå till nästa steg</v-toolbar-title
                  ></v-toolbar
                >
                <v-select
                  :items="membernameandId"
                  item-text="[0]"
                  item-value="[1]"
                  label="Ägare för nästa steg"
                  hint="Vem ska äga nästa steg?"
                  v-model="NewStep.ownerId"
                  required
                ></v-select>

                <v-text-field
                  label="Kommentar"
                  hint="Kommentera detta steg"
                  v-model="stepMessage"
                  required
                ></v-text-field>

                <div class="headline">Gå vidare till:</div>
                <v-btn
                  v-for="Option in NextstepOptions(
                    Choosen.steps[Choosen.steps.length - 1].step
                  )"
                  :key="Option.text"
                  dark
                  :color="Option.color"
                  @click="
                    NewStep.step = Option.text;
                    NewStep.comment = stepMessage;
                    showSuccessSnackbar(
                      'Ärendet har gått vidare till ' +
                        NewStep.step +
                        ' för att ändra eller se ärendets tidigare steg, titta då i tidslinjen nedan.'
                    );
                    UpdateCase([Choosen, NewStep]);
                    ChoosenOld = Choosen;
                  "
                >
                  {{ Option.text }}
                </v-btn>
                <!-- <v-btn
                      dark
                      color="green darken-1"
                      @click="showSuccessSnackbar('Ärendet har gått vidare till '+Nextstep(Choosen.steps[Choosen.steps.length - 1].step)+' för att ändra eller se ärendets tidigare steg, titta då i tidslinjen nedan.');UpdateCase([Choosen, NewStep]);        ChoosenOld = Choosen;"
                    >
                      Gå vidare till
                      {{
                        Nextstep(Choosen.steps[Choosen.steps.length - 1].step)
                      }}
                    </v-btn> -->
              </v-flex>
            </v-expand-transition>
            <v-expand-transition>
              <div v-if="Timeline">
                <v-toolbar color="red darken-1" dark>
                  <v-toolbar-title class="headline"
                    >Tidslinje</v-toolbar-title
                  ></v-toolbar
                >
                <v-timeline align-top :dense="$vuetify.breakpoint.smAndDown">
                  <v-timeline-item
                    v-for="(item, i) in Steps"
                    :key="i"
                    :color="item.color"
                    :icon="item.icon"
                    fill-dot
                  >
                    <v-card :color="item.color" dark>
                      <v-card-title class="title">
                        {{ item.text }}
                        <v-spacer></v-spacer>
                        <v-btn
                          v-if="Choosen.steps.length > i"
                          icon
                          @click="
                            item.edit = !item.edit;
                            showTipSnackbar(
                              'Nu kan du ändra kommentaren i steget ' +
                                item.text
                            );
                          "
                        >
                          <v-icon :color="item.edit ? 'yellow' : 'white'"
                            >edit</v-icon
                          >
                        </v-btn>
                      </v-card-title>
                      <v-card-text
                        class="white text--secondary"
                        v-if="Choosen.steps.length > i"
                      >
                        <v-text-field
                          :disabled="!item.edit"
                          class="blackforeground"
                          prefix="Kommentar: "
                          hint="Ändra kommentaren"
                          v-model="Choosen.steps[i].comment"
                          :append-outer-icon="'send'"
                          @click:append-outer="update(i)"
                        ></v-text-field>
                        <p>
                          Tid:{{ locfun.getDate(Choosen.steps[i].starttime) }}
                        </p>

                        <v-btn :color="item.color" class="mx-0" outlined>
                          Ägare:{{
                            locfun.getName(
                              Choosen.steps[i].ownerId,
                              teachernameandId,
                              membernameandId
                            )
                          }}
                        </v-btn>
                      </v-card-text>
                      <v-card-text class="white text--primary" v-else>
                        <p>Inte än påbörjat</p>
                      </v-card-text>
                    </v-card>
                  </v-timeline-item>
                </v-timeline>
              </div>
            </v-expand-transition>
            <v-expand-transition>
              <v-flex v-if="Feedback">
                <v-toolbar color="blue darken-1" dark>
                  <v-toolbar-title class="headline"
                    >Återkoppling</v-toolbar-title
                  ></v-toolbar
                >
                <v-text-field
                  label="Återkoppling till lärare"
                  hint="Detta kommer lärare kunna se"
                  v-model="Choosen.feedback"
                  required
                ></v-text-field>
                <v-flex
                  v-if="Choosen.hasOwnProperty('feedbackTime')"
                  cols="12"
                  sm="6"
                  md="4"
                >
                  <p>
                    Senaste återkopplingen gavs
                    {{ locfun.getDate(Choosen.feedbackTime) }} av
                    {{
                      locfun.getName(Choosen.feedbackGiver, [], membernameandId)
                    }}
                  </p>
                </v-flex>

                <v-flex v-if="Choosen.hasOwnProperty('feedbackReceiver')">
                  <div class="headline">Lärar-reaktioner:</div>
                  <v-container>
                    <v-layout row wrap justify-start>
                      <v-flex
                        xs2
                        sm1
                        v-for="Receiver in Choosen.feedbackReceiver"
                        :key="Receiver.id"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-if="Receiver.opinion == 1"
                              class="mx-2"
                              fab
                              dark
                              small
                              v-bind="attrs"
                              v-on="on"
                              color="green ligthen-1"
                            >
                              <v-icon dark> thumb_up </v-icon>
                            </v-btn>
                            <v-btn
                              v-else-if="Receiver.opinion == -1"
                              class="mx-2"
                              fab
                              dark
                              small
                              v-bind="attrs"
                              v-on="on"
                              color="red ligthen-1"
                            >
                              <v-icon dark> thumb_down </v-icon>
                            </v-btn>
                            <v-btn
                              v-else
                              class="mx-2"
                              fab
                              dark
                              small
                              v-bind="attrs"
                              v-on="on"
                              color="blue ligthen-1"
                            >
                              <v-icon dark> account_circle </v-icon>
                            </v-btn>
                          </template>
                          <span
                            >{{
                              locfun.getName(Receiver.id, teachernameandId, [])
                            }}
                            | Datum: {{ locfun.getDate(Receiver.opened) }}</span
                          >
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-flex>
            </v-expand-transition>
          </v-flex>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn dark color="blue darken-1" @click="Update_Case"> Stäng </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import fun from "../functions";
import Discuss from "./Discuss";
import { mapActions } from "vuex";
export default {
  name: "Detail",
  components: {
    Discuss,
  },
  computed: {
    show: {
      get() {
        if (this.Choosen != null && this.value != this.dialog) {
          this.ChoosenOld = JSON.parse(JSON.stringify(this.Choosen));
          this.NewStep = {
            ownerId: this.Choosen.steps[this.Choosen.steps.length - 1].ownerId,
          };
          this.Steps = [];
          //Foreach step in db, find unique step and add to timeline.
          this.Choosen.steps.forEach((step) => {
            this.diffrentSteps.forEach((uniqueStep) => {
              if (step.step == uniqueStep.text) {
                this.Steps.push(uniqueStep);
                //  break;
              }
            });
          });
          let lastPlace = this.diffrentSteps.findIndex(
            (x) => x.text === this.Steps[this.Steps.length - 1].text
          );
          for (let i = lastPlace + 1; i < this.diffrentSteps.length; i++) {
            this.Steps.push(this.diffrentSteps[i]);
          }
          this.Steps = this.Steps.map((obj) => ({ ...obj, edit: false }));
        }
        this.dialog = this.value;
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    this.locfun = new fun();
  },
  props: {
    Choosen: Object,
    teachernameandId: Array,
    membernameandId: Array,
    id: String,
    value: Boolean,
  },
  data() {
    return {
      // feedbackReceiver:[{id:"dY3f0ELmaNktKpsI09r4", opinion:0, opened:1626644374896 },{id:"dY3f0ELmaNktKpsI09r4", opinion:-1, opened:1626644374896 },{id:"dY3f0ELmaNktKpsI09r4", opinion:1, opened:1626644374896 },{id:"dY3f0ELmaNktKpsI09r4", opinion:0, opened:1626644374896 }
      // ,{id:"dY3f0ELmaNktKpsI09r4", opinion:0, opened:1626644374896 },{id:"dY3f0ELmaNktKpsI09r4", opinion:-1, opened:1626644374896 },{id:"dY3f0ELmaNktKpsI09r4", opinion:1, opened:1626644374896 },{id:"dY3f0ELmaNktKpsI09r4", opinion:0, opened:1626644374896 }
      // ,{id:"dY3f0ELmaNktKpsI09r4", opinion:0, opened:1626644374896 },{id:"dY3f0ELmaNktKpsI09r4", opinion:-1, opened:1626644374896 },{id:"dY3f0ELmaNktKpsI09r4", opinion:1, opened:1626644374896 },{id:"dY3f0ELmaNktKpsI09r4", opinion:0, opened:1626644374896 },
      // {id:"dY3f0ELmaNktKpsI09r4", opinion:0, opened:1626644374896 },{id:"dY3f0ELmaNktKpsI09r4", opinion:-1, opened:1626644374896 },{id:"dY3f0ELmaNktKpsI09r4", opinion:1, opened:1626644374896 },{id:"dY3f0ELmaNktKpsI09r4", opinion:0, opened:1626644374896 }],
      NewStep: {},
      newComment: { memberId: this.id, comment: "" },
      stepMessage: "",
      NextHide: false,
      Timeline: false,
      Feedback: false,
      DiscussHide: false,
      ChoosenOld: null,
      dialog: false,
      updateStep: false,
      Steps: [],
      diffrentSteps: [
        {
          text: "Anmälan",
          color: "pink lighten-2",
          nextStep: [1],
          icon: "email",
        },
        {
          text: "Mottagen",
          color: "blue lighten-2",
          nextStep: [2],
          icon: "check_circle",
        },
        {
          text: "Granskning",
          color: "light-green darken-1",
          nextStep: [3, 6],
          icon: "search",
        },
        {
          text: "Åtgärder beslutas",
          color: "cyan lighten-2",
          nextStep: [4],
          icon: "gavel",
        },
        {
          text: "Åtgärder sätts in",
          color: "red darken-1",
          nextStep: [5, 2],
          icon: "arrow_right",
        },
        {
          text: "Återkoppling ges",
          color: "amber lighten-1",
          nextStep: [6],
          icon: "chat",
        },
        {
          text: "Avslut & Arkivering",
          color: "blue-grey darken-1",
          icon: "archive",
        },
      ],
    };
  },
  methods: {
    ...mapActions("cases", ["UpdateCase"]),

    ...mapActions(["showSuccessSnackbar", "showTipSnackbar"]),

    update(i) {
      this.Choosen.steps[i].starttime = Date.now();
      this.updateStep = true;
      this.showSuccessSnackbar("Kommentaren uppdaterad!");
      // this.UpdateCase([this.Choosen]);
    },
    Update_Case() {
      if (
        this.Choosen.hasOwnProperty("feedback") &&
        this.ChoosenOld.hasOwnProperty("feedback") == false
      ) {
        this.Choosen.feedbackGiver = this.id;
        this.Choosen.feedbackTime = Date.now();
        this.UpdateCase([this.Choosen]);
      }
      // else if (
      //   this.Choosen.subscribersId.length !=
      //   this.ChoosenOld.subscribersId.length
      // ) {
      //   this.UpdateCase([this.Choosen]);
      // }
      else if (this.Choosen.feedback != this.ChoosenOld.feedback) {
        this.Choosen.feedbackTime = Date.now();
        delete this.Choosen.feedbackReceiver;
        this.Choosen.feedbackGiver = this.id;
        this.UpdateCase([this.Choosen]);
      } else if (
        this.Choosen.steps[this.Choosen.steps.length - 1].ownerId !=
        this.ChoosenOld.steps[this.Choosen.steps.length - 1].ownerId
      ) {
        this.UpdateCase([this.Choosen]);
      } else if (this.updateStep == true) {
        //  (this.Choosen)
        //  ("Uppdatera kommentar")
        this.UpdateCase([this.Choosen]);
      } else {
        //  ("Didnt update")
      }

      this.newComment = { memberId: this.id, comment: "" };
      this.show = false;
      // this.Choosen = null;
      this.ChoosenOld = null;
    },
    //Lösning. När man laddat in datat, titta vilka steps som gjort o sen lägger man dem i en array o visar dem. Man har även möjligheten emd fler val på de so mar det.
    NextstepOptions(Step) {
      let next = "";
      for (let i = 0; i < this.diffrentSteps.length; i++) {
        if (Step == this.diffrentSteps[i].text) {
          if (!this.diffrentSteps[i].hasOwnProperty("nextStep")) {
            return [
              {
                text: "Återöppna",
                color: "blue darken-1",
                nextStep: [2],
                icon: "archive",
              },
            ];
          }
          next = this.diffrentSteps[i].nextStep;
        }
      }
      let output = [];
      for (let i = 0; i < next.length; i++) {
        // if (next == i) {
        output.push(this.diffrentSteps[next[i]]);
        // }
      }
      return output;
    },
    Nextstep(Step) {
      let next = "";
      for (let i = 0; i < this.Steps.length; i++) {
        if (Step == this.Steps[i].text) {
          next = this.Steps[i + 1].text;
          this.NewStep.step = next;
          return next;
        }
      }
      return "Avsluta";
    },
  },
};
</script>
<style >
.blackforeground .v-text-field__slot input {
  color: black !important;
}
</style>